import { WindowLocation } from "@reach/router";

export function wrapLayout(location: WindowLocation): boolean {
  return !location.pathname.startsWith("/wedding/invitation");
}
